module.exports = __webpack_public_path__ + "assets/img/Ic-QQ.5ebe92cd.svg";